import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";

export default function Journal() {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    api.get("/blog").then((r) => setPosts(r.data));
  }, []);

  const [featured, ...rest] = posts;

  return (
    <div>
      <section className="border-b border-border">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-16">
          <div className="label-eyebrow mb-4">Journal</div>
          <h1 className="font-display text-5xl md:text-6xl leading-[0.95] tracking-tight max-w-4xl">
            Reviews, guides, and <span className="italic text-[#C95B3B]">stories</span> from the water.
          </h1>
        </div>
      </section>

      <section>
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-16">
          {featured && (
            <Link to={`/journal/${featured.slug}`} className="grid grid-cols-1 lg:grid-cols-2 gap-10 mb-20 group" data-testid={`journal-featured-${featured.slug}`}>
              <div className="aspect-[4/3] overflow-hidden border border-border">
                <img src={featured.image_url} alt={featured.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
              </div>
              <div className="flex flex-col justify-center">
                <div className="label-eyebrow mb-3 text-[#C95B3B]">{featured.tag} · Featured</div>
                <h2 className="font-display text-4xl md:text-5xl leading-[0.95] tracking-tight mb-4">{featured.title}</h2>
                <p className="text-lg text-muted-foreground leading-relaxed mb-6">{featured.excerpt}</p>
                <span className="text-sm text-[#C95B3B] font-semibold">Read the story →</span>
              </div>
            </Link>
          )}

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {rest.map((post) => (
              <Link key={post.id} to={`/journal/${post.slug}`} className="card-flat block group" data-testid={`journal-post-${post.slug}`}>
                <div className="aspect-[4/3] overflow-hidden bg-[#E6E2D6]">
                  <img src={post.image_url} alt={post.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
                </div>
                <div className="p-6">
                  <div className="label-eyebrow mb-2 text-[#C95B3B]">{post.tag}</div>
                  <h3 className="font-display text-2xl leading-tight mb-2">{post.title}</h3>
                  <p className="text-sm text-muted-foreground line-clamp-2">{post.excerpt}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
